import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    async saveRelationship(params) {
        const formData = new FormData();
        formData.append("pid", params.pid);
        formData.append("actor_id", params.actor_id);
        formData.append("relation_id", params.relation_id);
        formData.append("actor_type", params.actor_type);
        formData.append("patient_name", params.patient_name);
        formData.append("entity_id", params.entity_id || "");

        const res = await Axios.post(
            `${baseURLci}client/pet/save_relation`,
            formData
        );

        if (res.data.state === 0) {
            return true;
        }

        return false;
    },

    async getRelationshipTypes(params) {
        const res = await Axios.get(
            `${baseURL}reference/patient-relation-type`,
            {
                params: {
                    filter_owner: params.filter_owner || "",
                    client_relation: params.client_relation || ""
                }
            }
        );

        if (
            res.data.response &&
            res.data.response.message &&
            res.data.response.message.code === 200
        ) {
            return res.data.response.resources;
        }

        return [];
    }
};
